import branchFundingSourceCreateComponent from './branch_funding_source.create.component';
import './branch_funding_source.create.scss'

let branchFundingSourceCreateModule = angular.module('branchFundingSourcecreate', [
  ])

  .component('branchFundingSourcecreate', branchFundingSourceCreateComponent)

  .name;

export default branchFundingSourceCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/create/index.js